import { mapSettingsDataPathMap } from '~/store/mapSettings/data/mapSettingsData.helpers';
import { extraColumnSettingsTools } from './columnsMapSettings.types';

export const allColumnSettingsTools = [
  ...Object.values(mapSettingsDataPathMap),
  ...Object.values(extraColumnSettingsTools),
];
